document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.js-accordionToggle');
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      this.classList.toggle('is-active');
      var content = this.nextElementSibling;
      content.classList.toggle('add-margin-b');
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  window.addEventListener('resize', function () {
    toggles.forEach(function (toggle) {
      if (toggle.classList.contains('is-active')) {
        var content = toggle.nextElementSibling;
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
